import * as React from 'react'

import {t} from '@lib/helpers'

const CTAButton = () => {
  return (
    <a
      href='#upload'
      title={t('pages.demo.shared.nav.upload_image')}
      className='DemoDetail__button'
      onClick={(event) => {
        event.preventDefault()
        const {hash} = event.target

        window.history.pushState(null, null, hash)
        document.querySelector(hash).scrollIntoView({behavior: 'smooth'})
      }}
    >
      {t('pages.demo.shared.nav.upload_image')}
    </a>
  )
}

export default CTAButton
